export const pages = {
	'boltSynopsis': { id: 'boltSynopsis', page: 'home', getter: () => import(/* webpackChunkName: 'boltSynopsis' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
